import { Component } from '@angular/core';
import { NavController, NavParams } from 'ionic-angular';
import {DataProvider} from '../../providers/data';

/**
 * Generated class for the InfoPage page.
 *
 * See https://ionicframework.com/docs/components/#navigation for more info on
 * Ionic pages and navigation.
 */

@Component({
  selector: 'page-info',
  templateUrl: 'info.html',
})
export class InfoPage {
  public curCountry: string;

  constructor(public navCtrl: NavController, public navParams: NavParams, private dataService: DataProvider) {
    this.curCountry = dataService.CURRENT_COUNTRY;
  }

  ionViewDidLoad() {
    console.log('ionViewDidLoad InfoPage');
  }

}



// WEBPACK FOOTER //
// ./src/pages/info/info.ts